import { ProductV2 } from '@common'
import cx from 'classnames'

import { isStoreSpecial } from '@/features/storefronts/productFilters'

import { ClashProductVideo } from './ClashOfClansVideoItem'

import styles from './ClashOfClansStoreSpecialHero.module.scss'

type Props = {
  product: ProductV2
  className?: string
}

export function ClashOfClansStoreSpecialVideoHero({ product, className }: Props) {
  const isStoreSpecialOffer = isStoreSpecial(product)
  const content = product.contents[0]

  return (
    <div className={cx(styles.VideoHero, className, { [styles.SpecialOfferHero]: isStoreSpecialOffer })}>
      <ClashProductVideo content={content} />
    </div>
  )
}
